
        <ol class="breadcrumb">
            <li><a routerLink="/resources" class="breadcrumb">Home</a></li>
            <li *ngFor="let breadcrumb of breadcrumbs">
                <a [routerLink]="[breadcrumb.url, breadcrumb.params]">{{ breadcrumb.label }}</a>
        </ol>
    